import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { AppointmentService } from 'src/app/services/appointment.service';
import { DiagnosticiansComponent } from '../diagnosticians/diagnosticians.component';
import { FormBuilder, FormGroup, Validators, AbstractControl, ValidatorFn } from '@angular/forms';
import { AuthenticationService } from 'src/app/services/authentication.service';

function mobileNumberLengthValidator(): Validators {
  return (control: AbstractControl): {[key: string]: any} | null => {
      const unformattedValue = control.value.replace(/\D/g, ''); // Remove non-digits
      const isValidLength = unformattedValue.length === 10;
      return isValidLength ? null : { 'invalidLength': { value: control.value } };
  };
}
function passwordValidator(): ValidatorFn {
  return (control: AbstractControl): {[key: string]: any} | null => {
    const password = control.value;

    if (!password || password.length === 0) {
      return { 'requiredPass': true };
    } else if (password.length < 6) {
      return { 'invalidPassLength': true };
    } else {
      
      return null;
    }
  };
}


function requiredNonWhitespaceValidator(control: AbstractControl): {[key: string]: any} | null {
  const isWhitespace = (control.value || '').trim().length === 0;
  const isValid = !isWhitespace;
  return isValid ? null : { 'requiredNonWhitespace': true };
}


function confirmPasswordValidator(controlName: string, matchingControlName: string): Validators {
  return (formGroup: FormGroup): {[key: string]: any} | null => {
    const control = formGroup.get(controlName);
    const matchingControl = formGroup.get(matchingControlName);

    if (!control || !matchingControl) {
      console.log("dask");
      return null;
    }

    return control.value === matchingControl.value ? null : { 'passwordMismatch': true };
  };
}


@Component({
  selector: 'app-create-user',
  templateUrl: './create-user.component.html',
  styleUrls: ['./create-user.component.scss'],
})
export class CreateUserComponent implements OnInit {
  successMessage: string = '';
  failureMessage: string = '';
  message!: string;
  user!: string;
  locations: any = [];
  error: boolean = false;
  passf = false;
  fail = false;
  invalid = false;

  constructor(
    private auth: AuthenticationService,
    private formBuilder: FormBuilder,
    private appointment: AppointmentService,
    private router: Router,
    private activatedRoute: ActivatedRoute
  ) {
  }
  userForm!: FormGroup;
  confPass: string = '';
  pass: string = '';
   mobileNumberLengthValidator(): Validators {
    return (control: AbstractControl): {[key: string]: any} | null => {
        const unformattedValue = control.value.replace(/\D/g, ''); // Remove non-digits
        const isValidLength = unformattedValue.length === 10;
        return isValidLength ? null : { 'invalidLength': true };
    };
  
}

  ngOnInit() {
    //  this.user=history.state['user'];
    const user = this.activatedRoute.snapshot.queryParamMap.get('user');
    if (user != null) {
      this.user = user;
    }


    this.appointment.getLocations().subscribe((res) => {
      this.locations = res;
    });
    let emailPattern = "^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$";


    this.userForm = this.formBuilder.group({
      locationId: ['', Validators.required],
      username: ['', Validators.required],
      firstName: ['', Validators.required],
      lastName: ['', [Validators.required, requiredNonWhitespaceValidator]],
      password: ['', [Validators.required, passwordValidator()]],
      confirmPassword: ['', [Validators.required, Validators.minLength(6)]],
      mobileNo: ['', [Validators.required, mobileNumberLengthValidator()]],
      email: ['', [Validators.required, Validators.pattern(emailPattern)]], 
      role: ['',],
    }, { validators: confirmPasswordValidator('password', 'confirmPassword') });

        this.trimInputValue(this.userForm.get('lastName'));


    const mobileNoControl = this.userForm.get('mobileNo');
    mobileNoControl?.valueChanges.subscribe(value => {
        const formattedValue = this.formatMobileNumber(value);
        if (formattedValue !== value) {
            mobileNoControl.setValue(formattedValue, { emitEvent: false });
        }
    });
  }
// Utility method to subscribe to a form control and trim its input
private trimInputValue(control: AbstractControl | null) {
  control?.valueChanges.subscribe(value => {
      if (typeof value === 'string') {
          control.setValue(value.trim(), { emitEvent: false });
      }
  });
}

  formatMobileNumber(value: string): string {
    if (!value) {
        return value;
    }

    // Remove all non-digits
    value = value.replace(/\D/g, '');

    // Apply formatting
    if (value.length <= 3) {
        return `(${value}`;
    } else if (value.length <= 6) {
        return `(${value.slice(0, 3)}) ${value.slice(3)}`;
    } else {
        return `(${value.slice(0, 3)}) ${value.slice(3, 6)}-${value.slice(6, 10)}`;
    }
}



  get f() { return this.userForm.controls; }


  routerBack() {
    if (this.user == 'Diagnostician') {
      this.router.navigate(['../diagnosticians']);
    } else if (this.user == 'Director') {
      this.router.navigate(['../directors']);
    }
  }
  submit() {
    console.log("Submit method called");
    console.log("Is form valid?", this.userForm.valid);
    // Mark all fields as touched if the form is invalid
 
    if (this.userForm.invalid) {
      Object.keys(this.userForm.controls).forEach(key => {
        const control = this.userForm.get(key);
        control?.markAsTouched({ onlySelf: true });
       
    });
        this.failureMessage = 'All fields are required. Please ensure all fields are filled out correctly.';
        this.successMessage = '';
        return;
    }

    // Prepare the form data for submission
    let role = [this.user.toUpperCase()];
    this.userForm.controls['role'].setValue(role);
    let createUserDetail = this.userForm.value;

    // Submit the form data
    this.auth.createUser(createUserDetail).subscribe(
        (res: any) => {
            if (res.code === '200') {
              console.log(res); 
                // Set the success message based on user type
                if (this.user === 'Diagnostician') {
                    this.successMessage = 'Diagnostician Created Successfully';
                    setTimeout(() => {
                    this.router.navigate(['../diagnosticians']);
                  }, 2500);
                } else if (this.user === 'Director') {
                    this.successMessage = 'Director Created Successfully';
                    setTimeout(() => {
                    this.router.navigate(['../directors']);
                  }, 2500);
                }
                this.failureMessage = '';
                this.userForm.reset();
            } else {
              
                this.failureMessage = 'An error occurred while creating the user. ' + res.message;
             
                this.successMessage = '';
            }
        },
        (err) => {
            // Handle server or network errors
            this.failureMessage = 'Failed to create director. Please try again.';
            this.successMessage = '';
            console.error('Error:', err.error.message);
        }
    );
}

}


